module.exports = __webpack_public_path__ + "static/media/sadIcon.7db524e1.svg";